export function memoriaClienteOculto(criterio) {
  return JSON.parse(JSON.stringify({ tentativasClienteOculto: criterio.tentativasClienteOculto || [], clienteOculto: criterio.clienteOculto || [] }));
}
export function notaClienteOculto(criterio, memoria) {
  if (Number(criterio.numero) === 1) {
    return Number((memoria.tentativasClienteOculto || []).reduce((s, t) => {
      const condicoes = t.condicoes || [];
      const elegivel = condicoes[0] && condicoes[0].atendido === true && (t.canal === 'TELEFONE' || condicoes[1] && condicoes[1].atendido === true);
      return s + (elegivel ? (t.itens || []).filter(i => i.atendido === true).length * 0.4 : 0);
    }, 0).toFixed(1));
  }
  const itens = Object.fromEntries((memoria.clienteOculto || []).map(i => [i.perguntaId, i.atendido]));
  if ((criterio.memoriaCalculo || '').includes('somente atendimento telefônico')) return 0;
  return (itens[63] === true && itens[64] === true && itens[65] === true ? 4 : 0) + (itens[67] === true ? 2 : 0);
}
